export const SOURCING = {
  path: 'talent-rediscovery',
  redirect: { name: 'network' },
  children: [
    {
      path: '',
      name: 'sourcing',
      redirect: { name: 'network' }
    },
    {
      path: 'invite-tracker',
      name: 'invite-tracker',
      redirect: { name: 'network' }
    }
  ]
};
